export function staticRecordQueryOptionsToRefreshSpec(options) {
    if (!options.refreshMode || options.refreshMode === "none") {
        return undefined;
    }
    return {
        mode: options.refreshMode,
        interval: (options.refreshIntervalSeconds || 30) * 1000, // Default: 30s.
    };
}
